import  {  useRef } from 'react'
import DocumentCard from './DocumentCard';
import AddButton from '../UIElements/AddButton';

export default function CustomerDocuments() {

  const dropdownRef = useRef<HTMLDivElement>(null);
  type DocumentItem = {
  id: number;
  title: string;
  fileName?: string;
  hasFile: boolean;
};
 const documents: DocumentItem[] = [
    { id: 1, title: "Article", hasFile: false },
    { id: 2, title: "Statement", hasFile: true, fileName: "pan.pdf" },
    { id: 3, title: "EIN", hasFile: true,fileName: "45445544" },
   
  ];

  const handleUpload = (id: number) => {
    console.log("Upload clicked for document id:", id);
  };

  return (<div className="flex flex-col h-[calc(86.5vh-200px)] 2xl:h-[calc(88vh-200px)] 4xl:h-[calc(92vh-200px)]">
      
      <div className="p-3 m-3 rounded-[10px] flex-1 border border-[#EEEEEE] bg-white pb-6 overflow-y-auto custom-scroll">

      <div className='w-full flex items-center justify-between pb-3 mb-2 border-b-[1px] border-b-[#EEEEEE]'>
        <div >
<div className='flex items-center '>
     <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#007070"
    width="24"
    height="24"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 5V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V9C20 7.34315 18.6569 6 17 6H5C4.44772 6 4 5.55228 4 5ZM7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H16C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H8C7.58579 12.75 7.25 12.4142 7.25 12ZM7.25 15.5C7.25 15.0858 7.58579 14.75 8 14.75H13.5C13.9142 14.75 14.25 15.0858 14.25 15.5C14.25 15.9142 13.9142 16.25 13.5 16.25H8C7.58579 16.25 7.25 15.9142 7.25 15.5Z"
      fill="#007070"
    />
    <path
      d="M4.40879 4.0871C4.75727 4.24338 5 4.59334 5 5H17C17.3453 5 17.6804 5.04375 18 5.12602V4.30604C18 3.08894 16.922 2.15402 15.7172 2.32614L4.91959 3.86865C4.72712 3.89615 4.55271 3.97374 4.40879 4.0871Z"
      fill="#007070"
    />
  </svg>
  <span className="text-[13.5px] font-medium text-gray-900 ml-2">Documents</span>
</div>
<span
                    className="block text-[13px] text-customGray2 font-medium ml-6 mt-1"
                >
                1 Documents Uploaded
                </span>
                </div>
<div>
      <AddButton label="Add Document"
                            />
</div>
      </div>
     <div className="flex flex-wrap gap-4">
          {documents.map((doc) => (
            <DocumentCard
              key={doc.id}
              item={doc}
              onUpload={handleUpload}
            />
          ))}
        </div>

    </div>
  </div>
  )
}
